import Search from "../../MainContent/Search/Search";
import Marquee from "../../Marquee/Marquee"

const Laws = () => {
    return (
        <div>
            <div className="container">
                <Search />
                <h4 class="pb-4 pt-4 mb-4  ">
                    Қонунҳо
                </h4>
                <div>
                    <p> <a href="https://www.maorif.tj/storage/Dokument's/8c07dc3db99e254fd47eb04b52696c9e.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ МАОРИФ</a></p>

                    <p> <a href="https://www.maorif.tj/storage/Dokument's/b32166b527e35523533c96b092e8aae2.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ТАЪЛИМУ ТАРБИЯИ ТОМАКТАБӢ</a></p>
                    <p><a href="https://www.maorif.tj/storage/Dokument's/fbf173bc42d3cd825025d096461b2b00.pdf"> ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ТАҲСИЛОТИ  ИБТИДОИИ КАСБӢ</a></p>

                    <p> <a href="https://www.maorif.tj/storage/Dokument's/4cb1e4592fac8cb3324e058992bbad8e.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ТАҲСИЛОТИ МИЁНАИ КАСБӢ</a></p>

                    <p> <a href="https://www.maorif.tj/storage/Dokument's/6155af29bc8ee8337ec60493d661565d.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ТАҲСИЛОТИ ОЛИИ КАСБӢ ВА ТАҲСИЛОТИ КАСБИИ БАЪД АЗ МУАССИСАИ ОЛИИ ТАЪЛИМӢ</a></p>

                    <p><a href="https://maorif.tj/storage/Dokument's/46c7a999f29177f6e7a6090caf9e3321.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ  ТАҲСИЛОТИ  ИЛОВАГӢ</a></p>

                    <p> <a href="https://maorif.tj/storage/Dokument's/7d01ab16d87bcc655c8660ef15b1df8e.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ  АДАБИЁТИ ТАЪЛИМӢ</a></p>

                    <p> <a href="https://maorif.tj/storage/Dokument's/ILM%20INOVATION/5bdd72562defb6781904640c07c5f0a3.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ФАЪОЛИЯТИ ИЛМӢ ВА СИЁСАТИ  ДАВЛАТӢ ОИД БА ИЛМУ ТЕХНИКА</a> </p>

                    <p><a href="https://maorif.tj/storage/Dokument's/ILM%20INOVATION/30d09e083be49249bcfbee0d45624109.pdf"> ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОНД ДАР БОРАИ МАЪРИФАТИ ЭКОЛОГИИ АҲОЛӢ</a></p>

                    <p> <a href="https://maorif.tj/storage/Dokument's/ILM%20INOVATION/f2d39af8d13fe39fc02a068cd7881af0.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ЗАБОНИ ДАВЛАТИИ ҶУМҲУРИИ ТОҶИКИСТОН</a> </p>

                    <p> <a href="https://maorif.tj/storage/Dokument's/ILM%20INOVATION/2a2691304343feb5b7d713c9bf99222a.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ФАЪОЛИЯТИ ИННОВАТСИОНӢ</a> </p>

                    <p> <a href="https://maorif.tj/storage/Dokument's/ILM%20INOVATION/8959b73a894a73fde5729dd2c88bba7b.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ПАРКИ ТЕХНОЛОГИ</a> </p>
                    <p> <a href="https://maorif.tj/storage/Dokument's/ILM%20INOVATION/f8a443d6dae766c54d87d720aa476740.pdf">ҚОНУНИ ҶУМҲУРИИ ТОҶИКИСТОН ДАР БОРАИ ЭКСПЕРТИЗАИ ИЛМӢ ВА ИЛМИ-ТЕХНИКӢ</a></p>
                    <p> <a href="https://www.maorif.tj/asosi/sanadoi-oid-ba-ifzi-uui-kdak">САНАДҲОИ МЕЪЁРӢ-ҲУҚУҚИИ ҶУМҲУРИИ ТОҶИКИСТОН ОИД БА ҲИФЗИ ҲУҚУҚИ КӮДАК</a></p>

                    <p> <a href="https://maorif.tj/asosi/sanadoi-meyor-uuii-bajnalmilal-oid-ba-ifzi-uui-kdak">САНАДҲОИ МЕЪЁРӢ-ҲУҚУҚИИ БАЙНАЛМИЛАЛӢ ОИД БА ҲИФЗИ ҲУҚУҚИ КӮДАК </a></p>
                </div>

            </div>
            <Marquee/>
        </div >
    )
}
export default Laws;